<template>
  <div class="scene">
    <scene1 class="scene-1"></scene1>
    <scene2 class="scene-2"></scene2>
    <scene3 class="scene-3"></scene3>
    <div class="skip" title="跳过引导" @click="goHome">SKIP</div>
  </div>
</template>

<script>
import Scene1 from './components/Scene-01'
import Scene2 from './components/Scene-02'
import Scene3 from './components/Scene-03'
export default {
  name: 'Scene',
  components: {
    Scene1, Scene2, Scene3
  },
  data () {
    return {
    }
  },
  mounted () {
    setTimeout(this.goHome, 26000)
  },
  methods: {
    goHome () {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
.scene
  height 100%
  position relative
  .scene-1,.scene-2,.scene-3,.scene-4
    position absolute
    top 0
    left 0
  .scene-1
    z-index 3
  .scene-2
    z-index 2
  .scene-3
    z-index 1
  .skip
    position fixed
    top 5%
    right 30px
    z-index 99
    padding 15px 20px
    color #FFFFFF
    background $navBgColor
    border-radius 5px
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/pages/scene/Scene.vue